// import React, { useContext, useEffect, useState } from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";
// import { AuthContext } from "../Context/AuthContext";

// const ProtectedRoute = ({ requiredModule }) => {
//   const { user, logout, allowedModules } = useContext(AuthContext);
//   const [authorized, setAuthorized] = useState(null);

//   useEffect(() => {
//     const checkToken = () => {
//       const token = Cookies.get("authToken");
//       if (!token) {
//         setAuthorized(false);
//         return;
//       }

//       try {
//         const decoded = jwtDecode(token);
//         if (decoded.exp * 1000 < Date.now()) {
//           Cookies.remove("authToken");
//           logout?.();
//           setAuthorized(false);
//         } else {
//           setAuthorized(true);
//         }
//       } catch (err) {
//         Cookies.remove("authToken");
//         logout?.();
//         setAuthorized(false);
//       }
//     };

//     checkToken();
//   }, [user, logout]);

//   if (authorized === null) {
//     return (
//       <div
//         style={{
//           height: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
//           color: "#fff",
//           fontSize: "1.2rem",
//           fontWeight: "500",
//         }}
//       >
//         Loading..
//       </div>
//     );
//   }

//   if (!authorized) return <Navigate to="/signin" replace />;

//   if (requiredModule) {
//     if (!allowedModules.includes(requiredModule)) {
//       return <Navigate to="/unauthorized" replace />;
//     }
//   }
  
//   return <Outlet />;
// };

// export default ProtectedRoute;


import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";

const ProtectedRoute = ({ requiredModule }) => {
  const { user, allowedModules } = useContext(AuthContext);

  // Not logged in
  if (!user) return <Navigate to="/signin" replace />;

  // Check module permission
  if (requiredModule && !allowedModules.includes(requiredModule)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
